import React, { useEffect, useState } from 'react';
import './Lifeprediction.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

import Topbar from './Topbar';
import LIFEPREDECTIONORANGE from '../images/LIFEPREDECTIONORANGE.jpg_large';
import LIFEPREDICTION from '../images/LIFEPREDICTION.webp';
import LIFEPREDICTHERO from '../images/LIFEPREDICTHERO.jpg'; 

import Reviews from './Reviews';
import WORLDMAPJPG from '../images/WORLDMAPJPG.jpg'; // Adjust path as necessary

export default function Lifeprediction() {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // State to manage open/close state of each FAQ item
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index); // Close if already open, otherwise open
  };

  return (
    <div>
  
    <div><Navbar /></div>
    <div>
      <section id="hero" style={{ backgroundImage: `url(${LIFEPREDICTHERO})` }}>
        <div className="hero-content">
          <h1>SHIVA NADI ASTROLOGY</h1>
          <p>Ancient Wisdom | Future Insights</p>
          <center>
            <p id="langu">Telugu | Hindi | Malayalam | Tamil | English</p>
            </center>
          <a href="tel:+919876543210" className="hero-btn">Book Service?</a>
        </div>
      </section>

      <section id="About">
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
              <h2>About</h2>
              <p>Welcome to Shiva Nadi Astrology! With over 32 years of profound experience in the ancient art of Nadi Astrology, we are honored to be your trusted guide on the journey of self-discovery and life predictions. Whether you seek clarity about your future, solutions to challenges, or a deeper understanding of your life's purpose, our wisdom and expertise are here to illuminate your path.

At Shiva Nadi Astrology, we understand the significance of accurate and insightful predictions to guide your personal and spiritual growth. With the blessings of Lord Shiva, we decode the divine messages written in ancient palm leaves, offering you personalized insights about your past, present, and future.

Transparency is at the heart of our service. We believe trust and authenticity are the foundations of a meaningful relationship, which is why we provide clear and comprehensive guidance throughout the process. Our experienced astrologers deliver precise predictions, remedies, and spiritual guidance tailored to your unique life path.

Customer satisfaction is our utmost priority. With timely, compassionate, and professional assistance, we ensure your experience is transformative and fulfilling. Whether you're seeking answers about your career, relationships, health, or spirituality, Shiva Nadi Astrology is here to provide profound insights, turning your life questions into clarity.

Let our 32 years of expertise in Nadi Astrology help you uncover your destiny and embrace a harmonious future today!</p>

            </div>
          </div>
        </div>
      </section>



      <section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<h2>Ancient Wisdom | Future Insights</h2>


</div>

</div>

</div>
</section>
<section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<img src={WORLDMAPJPG} alt="Gallery Image 1" className="img-fluid rounded" />

</div>
<h5>We Offer Our Service All Over The World</h5>
</div>

</div>
</section>

<section id="nadi-intro">
    <h1>Welcome to Nadi Astrology</h1>
    <p>Nadi Astrology is an ancient Indian practice that decodes divine messages written on palm leaves, offering profound insights into your past, present, and future.</p>
  </section>

  <section class="nadi-section">
    <div class="nadi-card">
      <i class="fas fa-fingerprint"></i>
      <h2>1. Identifying the Seeker</h2>
      <p>The process begins with the seeker providing their thumb impression. The right thumb impression is taken for men, and the left for women.</p>
    </div>
  </section>

  <section class="nadi-section">
    <div class="nadi-card">
      <i class="fas fa-scroll"></i>
      <h2>2. Finding the Correct Palm Leaf</h2>
      <p>Astrologers select a bundle of palm leaves based on the thumb impression and use yes/no questions to identify the correct one.</p>
    </div>
  </section>

  <section class="nadi-section">
    <div class="nadi-card">
      <i class="fas fa-language"></i>
      <h2>3. Decoding the Palm Leaf</h2>
      <p>The astrologer reads the ancient Tamil script containing details about the seeker’s past, present, and future.</p>
    </div>
  </section>

  <section class="nadi-section">
    <div class="nadi-card">
      <i class="fas fa-chart-line"></i>
      <h2>4. Predictions and Life Path</h2>
      <p>Life predictions, including milestones and challenges, are shared to guide seekers on their journey.</p>
    </div>
  </section>

  <section class="nadi-section">
    <div class="nadi-card">
      <i class="fas fa-hand-holding-heart"></i>
      <h2>5. Remedies for Life Challenges</h2>
      <p>Remedies like poojas, mantras, and donations are suggested to align with your karmic path.</p>
    </div>
  </section>

  <section class="nadi-section">
    <div class="nadi-card">
      <i class="fas fa-star"></i>
      <h2>6. Personalized Experience</h2>
      <p>Each leaf is unique, helping seekers align their actions with their destiny, guided by divine wisdom.</p>
    </div>
  </section>



      <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={LIFEPREDICTION} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Life's Mysteries with Nadi Astrology</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>At our Nadi Astrology center, we specialize in unveiling the secrets of your past, present, and future through the ancient wisdom of palm leaf inscriptions. Whether you're seeking guidance on personal relationships, career paths, or spiritual growth, our trusted astrologers are here to help you find clarity and direction.

With years of expertise in decoding these sacred texts, we provide accurate life predictions and tailored remedies to overcome challenges and align with your destiny. From identifying your unique palm leaf to interpreting its profound messages, we ensure a seamless and enlightening experience every step of the way.

Our commitment to transparency, precision, and spiritual guidance ensures that your journey of self-discovery is meaningful and stress-free. Let us help you unlock the divine insights hidden in Nadi Astrology and empower you to shape your life's path with confidence and purpose.</p>
    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={LIFEPREDECTIONORANGE} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Discover Your Destiny</h3>
      </div>
    </div>
    <div className="col-md-6">
      <p>At our Nadi Astrology center, we offer an insightful and transformative experience to help you uncover your life’s purpose. With the wisdom of ancient palm leaf inscriptions, we decode the divine messages that hold the key to your past, present, and future.

Our skilled astrologers specialize in interpreting your unique life path, providing guidance on relationships, career, health, and spiritual growth. With a focus on accuracy and transparency, we ensure a seamless and enlightening process, from identifying your palm leaf to sharing profound predictions and remedies tailored to your destiny.

Trust in our expertise to guide you toward clarity and purpose. Whether you seek answers or solutions, Nadi Astrology empowers you to embrace life’s opportunities with confidence and understanding. Let us help you align with your karmic journey and unlock the secrets of your destiny.</p>
    </div>
  </div>

</section>


<section id="why-choose-us">
  <div class="container">
    <h2>Why Choose Us?</h2>
    <div class="features">
      <div class="feature-box">
        <i class="icon fas fa-trophy"></i>
        <h3>Proven Expertise</h3>
        <p>Over a decade of experience delivering top-notch services to clients.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-user-check"></i>
        <h3>Customer Satisfaction</h3>
        <p>Our clients are our priority, and we go the extra mile to meet their needs.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-chart-line"></i>
        <h3>Results-Driven</h3>
        <p>We focus on achieving measurable outcomes for your success.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-headset"></i>
        <h3>24/7 Support</h3>
        <p>Our team is available around the clock to assist with any concerns.</p>
      </div>
    </div>
  </div>
</section>








<div><Reviews/></div>



{/* Other sections */}
<section id="faq-land">
  <div className="container">
    <h2>FAQs - Frequently Asked Questions</h2>
    <div className="accordion">
      {[
        {
          question: "How can Apollo Agency assist with land purchases?",
          answer: "We provide comprehensive support, from identifying suitable plots to legal documentation and registration.",
        },
        {
          question: "Do you offer services for land leasing?",
          answer: "Yes, we facilitate land leasing, including contract preparation and tenant verification.",
        },
        {
          question: "Can Apollo Agency help with land sales?",
          answer: "Absolutely, we assist in marketing your land, finding potential buyers, and negotiating the best deals.",
        },
        {
          question: "What kind of lands do you deal with?",
          answer: "We specialize in residential plots, agricultural land, commercial land, and industrial spaces.",
        },
        {
          question: "Why should I trust Apollo Agency for land services?",
          answer: "With years of experience, transparency, and a customer-centric approach, we ensure reliable and hassle-free transactions.",
        },
        {
          question: "Do you offer valuation services for land?",
          answer: "Yes, we provide expert valuation services to help you determine the current market value of your property.",
        },
      ].map((faq, index) => (
        <div className="accordion-item" key={index}>
          <div className="accordion-header" onClick={() => toggleFaq(index)}>
            <h3>{faq.question}</h3>
            <i className={`icon fas fa-chevron-${openFaq === index ? "up" : "down"}`}></i>
          </div>
          <div className={`accordion-content ${openFaq === index ? "open" : ""}`}>
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>




<section id="contact-info">
  <h2>Contact Us</h2>
  <div class="contact-container">
    <div class="contact-item">
      <i class="fas fa-map-marker-alt"></i>
      <h3>Office Address</h3>
      <p>LIG- B, Plot No: 204, Dr. AS Rao Nagar Rd, beside SUB POST OFFICE, Anupuram Colony, A. S. Rao Nagar, Hyderabad, Secunderabad, Telangana 500062</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact</h3>
      <p>Phone: +91 74021 67580<br/>Email:shivanadiastrologer@gmail.com</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-map"></i>
      <h3>Map</h3>
      <p>
      <a href="https://www.google.com/maps?q=LIG-+B,+Plot+No:+204,+Dr.+AS+Rao+Nagar+Rd,+beside+SUB+POST+OFFICE,+Anupuram+Colony,+A.+S.+Rao+Nagar,+Hyderabad,+Secunderabad,+Telangana+500062" target="_blank">View on Google Maps</a>

      </p>
    </div>
  </div>
</section>

      <section id="opening-hours">
  <h2>Opening Hours</h2>
  <table class="hours-table">
    <thead>
      <tr>
        <th>Day</th>
        <th>Time</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Monday to Saturday
        </td>
        <td>
          <i class="fas fa-clock"></i> 10 AM - 7 PM
          <br/>
          <i class="fas fa-utensils"></i> Lunch: 2 PM - 3 PM
        </td>
      </tr>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Sunday
        </td>
        <td>
          <i class="fas fa-times-circle"></i> Closed
        </td>
      </tr>
    </tbody>
  </table>
</section>






    
    <div><Footer /></div>
  </div>
  </div>
  )
}
